import {useEffect} from 'react';

import {oneOfType, node, func, bool} from 'prop-types';
import {useNavigate} from 'react-router-dom';

import {APP_ROUTES} from '../const';
import useAuth from '../hooks/providers/useAuth';
import useLoading from '../hooks/providers/useLoading';
import usePayment from '../hooks/providers/usePayment';
import useProfile from '../hooks/providers/useProfile';
import useProjects from '../hooks/providers/useProjects';
import useReport from '../hooks/providers/useReport';

const RequireSubscription = ({children, requiresSubscriptionOrTrial = false}) => {
  const {paidFeaturesDisabled, authorizationsLoading: loading, authorizationsLoaded, getUserSubscriptionStatus, hasTrialEnded} = usePayment();
  const auth = useAuth();
  const navigate = useNavigate();
  const {setCompletedApiCalls} = useLoading();
  const {fetchProjects} = useProjects();
  const {loadReports} = useReport();
  const {getOnboarding} = useProfile();

  useEffect(() => {
    (async () => {
      if (!auth?.user?.tokenAad) return;

      console.log({isNewUser: auth.isNewUser});
      if (auth.isNewUser) {
        await fetchProjects();
        await Promise.all([getUserSubscriptionStatus(), loadReports(), getOnboarding()]);
        setCompletedApiCalls(prevCompleted => prevCompleted + 3);
      } else {
        await Promise.all([getUserSubscriptionStatus(), loadReports(), getOnboarding()]);
        setCompletedApiCalls(prevCompleted => prevCompleted + 2);
      }
    })();
  }, [auth?.user?.tokenAad, auth.isNewUser]);

  const canUserAccessRestrictedPages = () => {
    if (hasTrialEnded || paidFeaturesDisabled) return false;
    return true;
  };

  useEffect(() => {
    if (!authorizationsLoaded) return;

    if (requiresSubscriptionOrTrial && !canUserAccessRestrictedPages()) {
      navigate(APP_ROUTES.restrictedAccess);
    }
  }, [requiresSubscriptionOrTrial, hasTrialEnded, authorizationsLoaded, paidFeaturesDisabled]);

  if (loading || !authorizationsLoaded) {
    return null;
  }

  return children;
};

RequireSubscription.propTypes = {
  children: oneOfType([node, func]).isRequired,
  // eslint-disable-next-line react/boolean-prop-naming
  requiresSubscriptionOrTrial: bool
};

export default RequireSubscription;
